import { render, staticRenderFns } from "./SummaryAffiliate.vue?vue&type=template&id=8d7854ac&"
import script from "./SummaryAffiliate.vue?vue&type=script&lang=js&"
export * from "./SummaryAffiliate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports